import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { Container, Card, Form, Row, Col, Button } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import PageTitle from 'src/components/general/PageTitle';
import { HOLIDAY_LIST } from 'src/utils/constants';
import { getHolidayEditIsFetching, getHolidayToEdit, getHolidayTypeListIsFetching } from 'src/redux/holiday/holidayReducer';
import { tryEditHoliday } from 'src/redux/holiday/holidayActionCreator';
import HolidayForm from '../../forms/Holiday/HolidayForm';
import AppLoading from 'src/components/common/AppLoading';

const HolidayEditPage = () => {

    const dispatch = useDispatch();

    const hookFormMethods = useForm();
    const { handleSubmit } = hookFormMethods;

    const holidayToEdit = useSelector(state => getHolidayToEdit(state));
    Object.assign(hookFormMethods, { holidayToEdit });

    const editHolidayIsFetching = useSelector(state => getHolidayEditIsFetching(state));
    const holidayTypeListIsFetching = useSelector(state => getHolidayTypeListIsFetching(state));

    const onFormSubmit = data => {
        const date = data?.year;
        const name = data?.name;
        const typeId = data?.typeId;

        const params = {
            date: date,
            name: name,
            holidayType: { "id": typeId },
            id: holidayToEdit?.id
        };

        dispatch(tryEditHoliday(params));
    };

    return <Container fluid className='mb-5'>
        <Card>
            <PageTitle text='Feriado' />
            <Container fluid>
                <Card className='mb-3'>
                    <Card.Header>
                        <h6 className='mb-0'>Editar Feriado</h6>
                    </Card.Header>
                    <Card.Body >
                        <Row>
                            <Col xs={8}>
                                <h6 className='mb-4 text-black-color'>
                                </h6>
                            </Col>
                            <Col xs={4} className='text-right font-weight-bold font-italic'>
                                <span className='text-danger d-flex mandatory-label'>
                                    <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                                    Requerido
                                </span>
                            </Col>
                        </Row>
                        <FormProvider {...hookFormMethods} >
                            <Form onSubmit={handleSubmit(onFormSubmit)} autoComplete='off'>
                                <HolidayForm />
                                <div className='d-flex justify-content-around mt-4 mb-3'>
                                    <Button
                                        variant='danger'
                                        size='lg'
                                        disabled={editHolidayIsFetching}
                                        onClick={() => dispatch(push(HOLIDAY_LIST))}
                                    >
                                        Cancelar
                                    </Button>

                                    <Button
                                        type='submit'
                                        variant='success'
                                        size='lg'
                                        disabled={editHolidayIsFetching || holidayTypeListIsFetching}
                                    >
                                        Guardar
                                    </Button>
                                </div>
                            </Form>
                        </FormProvider>
                    </Card.Body>
                </Card>
            </Container>
        </Card>
        <AppLoading isLoading={editHolidayIsFetching} />
    </Container>;
};

export default HolidayEditPage;